import React, { useState } from 'react';
import Sidebar from '../Components/Sidebar.jsx';
import { TfiHandPointRight } from "react-icons/tfi";
import './Elevation.css';

const Elevation = () => {
  const [zoomImage, setZoomImage] = useState(null);

  const elevationImages = [
    '/gallery/3D_Elevation_Drawings/3D_Elevation_1.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_2.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_3.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_4.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_5.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_6.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_7.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_8.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_9.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_10.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_11.jpeg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_12.jpeg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_13.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_14.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_15.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_16.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_17.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_18.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_19.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_20.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_21.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_22.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_23.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_24.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_25.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_26.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_27.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_28.png',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_29.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_30.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_31.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_32.jpg',
    '/gallery/3D_Elevation_Drawings/3D_Elevation_33.jpg',
  ];

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />

      <div className="elevation-content">
        <h1 className="service-title">3D ELEVATION DRAWINGS</h1>

{/* Main hero image */}
        <div className="service-image">
          <img src="/gallery/3D_Elevation_Drawings/3D_Elevation_33.jpg" alt="Structural Drawing" />
        </div>
        <h3>Why Choose Our Draftsman Services?</h3>
        <ul className="draftsman-points">
          <li><TfiHandPointRight /> Accurate and detailed structural & architectural plans</li>
          <li><TfiHandPointRight /> Expert in 2D planning, sections, and elevations</li>
          <li><TfiHandPointRight /> AutoCAD & Revit supported drafting</li>
          <li><TfiHandPointRight /> Precise measurements and to-scale outputs</li>
        </ul>

        {/* Gallery Section */}
        <div className="image-grid-section">
          <h2>Gallery of 3D Elevation Drawings</h2>
          <div className="image-grid">
            {elevationImages.map((src, index) => (
              <div
                key={index}
                className="grid-image-box"
                onClick={() => setZoomImage(src)}
              >
                <img src={src} alt={`Elevation ${index + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>

        {/* Contact Section */}
        <div className="service-contact">
          <h2>Contact Us for More Information</h2>
          <p>If you have any questions or would like to discuss your project, please contact us:</p>
          <ul>
            <li>Email: <a href="mailto:info@example.com">info@example.com</a></li>
            <li>Phone: <a href="tel:+919999999999">+91 99999 99999</a></li>
          </ul>
        </div>
      </div>

      {/* Zoom Modal */}
      {zoomImage && (
        <div className="image-modal" onClick={() => setZoomImage(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={() => setZoomImage(null)}>❌</span>
            <img src={zoomImage} alt="Zoomed View" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Elevation;
